import React, { useRef, useState } from "react";
import { observer } from "mobx-react-lite";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import { useStore } from "../../helpers";
import { Srstyledtabs } from "../../new-features";
import { StateSchemes } from "./state-schemes-view";
import { CentralSchemes } from "./central-schemes-view";
import { Box, Button } from "@mui/material";
import { safe_get } from "../../report-visuals";
import { useEligibleSchemes } from "./useEligibleSchemes";
import Typography from "@mui/material/Typography";

const Tabs = ["State Schemes", "Central Schemes"];

export const EligibleSchemesView = observer((props: any) => {
  const [currentTabValue, setCurrentTabValue] = useState(Tabs[0]);
  const { voterListStore, aiGentoolStore } = useStore();
  const { activeVoter } = voterListStore;
  const { voterdata } = props;
  const voterid = safe_get(activeVoter, "profile.voterid", null);
  const name = safe_get(activeVoter, "profile.name_eng", null);
  const {
    voterListStore: { voterEligibleSchemeList, voterSchemeProfile },
  } = useStore();

  // console.log(voterSchemeProfile, "Important");
  const stateSchemes = Array.isArray(
    voterEligibleSchemeList?.["scheme_list"]?.["State"],
  )
    ? voterEligibleSchemeList?.["scheme_list"]?.["State"]
    : [];
  const centralSchemes = Array.isArray(
    voterEligibleSchemeList?.["scheme_list"]?.["Central"],
  )
    ? voterEligibleSchemeList?.["scheme_list"]?.["Central"]
    : [];

  const booleanToYesNo = (value: any) => {
    if (value === true) return "Yes";
    if (value === false) return "No";
    return value;
  };

  const eligibilityInfoRef = useRef<HTMLDivElement | null>(null);

  const transformProfileData = (data: any) => {
    const transformed: any = {};

    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        const value = data[key];
        if (typeof value === "boolean") {
          transformed[key] = booleanToYesNo(value);
        } else if (
          value &&
          typeof value === "object" &&
          !Array.isArray(value)
        ) {
          transformed[key] = transformProfileData(value);
        } else {
          transformed[key] = value;
        }
      }
    }

    return transformed;
  };

  const onEditProfile = () => {
    voterListStore.update_voter_eligible_schemes(false);

    let eligibilityData = voterEligibleSchemeList?.["scheme_profile"] || {};

    eligibilityData = transformProfileData(eligibilityData);

    aiGentoolStore.setActiveEligibiltyDetails(eligibilityData);
    voterListStore.update_info_scheme(true);
  };

  const scrollToEligibilityInfo = () => {
    eligibilityInfoRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  console.log("State schemes", stateSchemes);
  return (
    <div>
      <div>
        <div className="flex flex-row justify-between bg-white mt-3 rounded-xl p-4 shadow-sm mb-4">
          <div className="flex flex-col">
            <h2 className="text-lg font-semibold text-gray-800">{name}</h2>
            <p className="text-sm text-gray-600 mt-1">{voterid}</p>
          </div>
          <Button
            variant="outlined"
            onClick={scrollToEligibilityInfo}
            sx={{
              ml: 2,
              textTransform: "none",
              borderRadius: "25px",
              fontSize: "0.85rem",
              padding: "2px 18px",
              border: "1px solid black",
              color: "black",
              backgroundColor: "transparent",
              "&:hover": {
                backgroundColor: "black",
                borderColor: "black",
                color: "white",
              },
            }}
          >
            See Eligibility Info
          </Button>
        </div>
        <TabContext value={currentTabValue}>
          <Srstyledtabs
            // @ts-ignore
            indicatorColor="common.black"
            variant="fullWidth"
            onChange={(e, value) => setCurrentTabValue(value)}
          >
            {Tabs.map((tab) => (
              <Tab key={tab} label={tab} value={tab} />
            ))}
          </Srstyledtabs>

          {/*<TabPanel value={Tabs[0]}>*/}
          {/*  <StateSchemes schemes={stateSchemes} />*/}
          {/*</TabPanel>*/}
          <TabPanel value={Tabs[0]}>
            <StateSchemes
              schemes={stateSchemes}
              voterid={voterid}
              voterdata={voterdata}
            />
          </TabPanel>

          <TabPanel value={Tabs[1]}>
            <CentralSchemes schemes={centralSchemes} />
          </TabPanel>
        </TabContext>
        <div className="bg-white mt-3 rounded-xl p-4 shadow-sm mb-4 mx-7">
          <div className="flex flex-row justify-between pb-4 ">
            <Typography
              variant={"h6"}
              color={"primary"}
              sx={{
                fontWeight: 600,
              }}
            >
              Eligibilty Info
            </Typography>
            <Button
              variant="outlined"
              onClick={onEditProfile}
              sx={{
                ml: 2,
                textTransform: "none",
                borderRadius: "25px",
                fontSize: "0.85rem",
                padding: "6px 18px",
                border: "1px solid black",
                color: "white",
                backgroundColor: "black",
                "&:hover": {
                  borderColor: "black",
                },
              }}
            >
              Edit Eligibility Info
            </Button>
          </div>
          {voterSchemeProfile && (
            <div
              className="flex flex-wrap gap-2 my-3 w-full "
              ref={eligibilityInfoRef}
            >
              {Object.entries(voterSchemeProfile).map(([key, value]) =>
                value ? (
                  <div
                    key={key}
                    className="bg-transparent border border-solid border-gray-700 dark:border-gray-500 text-gray-700 dark:text-gray-300  rounded-full py-2 px-4 text-xs font-medium leading-none cursor-pointer hover:shadow-md text-[#24262B] line-clamp-2 dark:text-indigo-100 text-xs lg:text-sm"
                  >
                    {key
                      .replace(/([A-Z])/g, " $1")
                      .replace(/^./, (str) => str.toUpperCase())}
                    : <span className="font-semibold">{String(value)}</span>
                  </div>
                ) : null,
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
});
